module.exports = __webpack_public_path__ + "img/icon-timer-2.a6596598.svg";